export const sidebarImage = (img: string) => ({
    type: 'BG_IMAGE',
    img
})

export const sidebarImageUrl = (imgurl: string) => ({
    type: 'BG_IMAGE_URL',
    imgurl
})

export const sidebarBgColor = (color: string) => ({
    type: 'BG_COLOR',
    color
})

export const sidebarCollapsed = (collapsed: boolean) => ({
    type: 'SIDEBAR_COLLAPSED',
    collapsed
})

export const sidebarSize = (size: number) => ({
    type: 'SIDEBAR_SIZE',
    size
})

export const showDropdownNavbar = (show: boolean) => ({
    type: 'SHOW_DROPDOWN_NAVBAR',
    show
})
